import React, { FC, MouseEvent, ReactNode } from 'react'
import styles from './borderedRow.module.scss'

interface BorderedRowProps {
  children?: ReactNode
  className?: string
  onClick?: (e: MouseEvent<HTMLTableRowElement>) => void
}

export const BorderedRow: FC<BorderedRowProps> = ({
  children,
  className,
  onClick,
}) => (
  <tr className={`${styles.borderedRow} ${className ?? ''}`} onClick={onClick}>
    {children}
  </tr>
)
